const BigMail = () => {
  return (
    <svg
      width="112"
      height="103"
      viewBox="0 0 112 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100.709 102.778H11.4088C8.48039 102.778 5.67191 101.615 3.6012 99.544C1.5305 97.4733 0.367188 94.6649 0.367188 91.7364V50.8235C0.367188 50.2293 0.488223 49.6414 0.722902 49.0956C0.957581 48.5498 1.30098 48.0575 1.73218 47.6488L49.0525 2.79305C50.9445 0.99964 53.4521 0 56.059 0C58.6658 0 61.1735 0.99964 63.0654 2.79305L108.183 45.5606C109.31 46.629 110.208 47.9157 110.821 49.3424C111.434 50.7691 111.751 52.3058 111.751 53.8588V91.7364C111.751 93.1864 111.465 94.6223 110.91 95.9619C110.355 97.3015 109.542 98.5187 108.517 99.544C107.491 100.569 106.274 101.383 104.935 101.938C103.595 102.492 102.159 102.778 100.709 102.778Z"
        fill="var(--primary)"
      />
      <path
        opacity="0.1"
        d="M0.367188 51.4952H110.823V96.1108C110.823 97.8791 110.12 99.5749 108.87 100.825C107.619 102.076 105.924 102.778 104.155 102.778H7.03448C5.26621 102.778 3.57035 102.076 2.31999 100.825C1.06963 99.5749 0.367188 97.8791 0.367188 96.1108V51.4952Z"
        fill="black"
      />
      <path
        d="M90.9392 16.3398H20.9444C17.5891 16.3398 14.8691 19.0598 14.8691 22.4151V92.4099C14.8691 95.7652 17.5891 98.4852 20.9444 98.4852H90.9392C94.2945 98.4852 97.0145 95.7652 97.0145 92.4099V22.4151C97.0145 19.0598 94.2945 16.3398 90.9392 16.3398Z"
        fill="var(--primaryLight)"
      />
      <path
        opacity="0.1"
        d="M97.0145 53.3401V98.4852H14.8691V53.3401L55.9418 73.1919L97.0145 53.3401Z"
        fill="black"
      />
      <path
        d="M55.9418 75.7443L3.31449 50.3078C2.98897 50.1504 2.62884 50.0783 2.26784 50.0982C1.90684 50.1181 1.5568 50.2293 1.25053 50.4214C0.944268 50.6136 0.691805 50.8803 0.516805 51.1967C0.341806 51.5131 0.25 51.8687 0.25 52.2303V95.9947C0.25 96.8702 0.422452 97.7372 0.757515 98.5461C1.09258 99.355 1.58369 100.09 2.20281 100.709C2.82192 101.328 3.55692 101.819 4.36583 102.154C5.17475 102.49 6.04174 102.662 6.9173 102.662H104.966C105.842 102.662 106.709 102.49 107.518 102.154C108.327 101.819 109.062 101.328 109.681 100.709C110.3 100.09 110.791 99.355 111.126 98.5461C111.461 97.7372 111.634 96.8702 111.634 95.9947V52.98C111.634 52.5388 111.522 52.1048 111.308 51.7188C111.094 51.3327 110.786 51.0072 110.413 50.7728C110.039 50.5383 109.612 50.4026 109.171 50.3783C108.731 50.354 108.291 50.442 107.894 50.634L55.9418 75.7443Z"
        fill="var(--primary)"
      />
      <path
        d="M44.9182 23.8813H21.9453V27.13H44.9182V23.8813Z"
        fill="var(--primary)"
      />
      <path
        d="M88.3123 35.7158H20.0898V37.5722H88.3123V35.7158Z"
        fill="var(--primary)"
      />
      <path
        d="M88.3123 41.9812H20.0898V43.8376H88.3123V41.9812Z"
        fill="var(--primary)"
      />
      <path
        d="M88.3123 48.2466H20.0898V50.103H88.3123V48.2466Z"
        fill="var(--primary)"
      />
      <path
        d="M18.2347 27.1647C23.4892 27.1647 27.7487 22.8974 27.7487 17.6334C27.7487 12.3694 23.4892 8.10205 18.2347 8.10205C12.9803 8.10205 8.7207 12.3694 8.7207 17.6334C8.7207 22.8974 12.9803 27.1647 18.2347 27.1647Z"
        fill="white"
      />
      <path
        d="M18.2337 6.47766C15.9848 6.47766 13.7865 7.14453 11.9166 8.39392C10.0468 9.64332 8.58941 11.4191 7.72881 13.4968C6.86821 15.5745 6.64304 17.8607 7.08176 20.0663C7.52049 22.272 8.60342 24.298 10.1936 25.8882C11.7838 27.4783 13.8098 28.5613 16.0154 29C18.2211 29.4387 20.5073 29.2135 22.585 28.3529C24.6626 27.4923 26.4384 26.035 27.6878 24.1651C28.9372 22.2953 29.6041 20.0969 29.6041 17.8481C29.5953 14.8352 28.3945 11.9482 26.264 9.81772C24.1336 7.68727 21.2466 6.48648 18.2337 6.47766ZM15.8995 23.9105L10.0721 18.0831L11.7066 16.4486L15.9049 20.6469L24.7662 11.7857L26.4007 13.4202L15.8995 23.9105L15.8995 23.9105Z"
        fill="var(--primary)"
      />
    </svg>
  );
};

export default BigMail;
